export const execute = (repository) => () => {
    return repository.getAll()
        .then(sort)
}

const sort = (pricelists) => {
    return pricelists.sort((e1, e2) => e1.name.toLowerCase() > e2.name.toLowerCase() ? 1 : -1);
};
